import { render, staticRenderFns } from "./TransparentBox.vue?vue&type=template&id=41d374b8&scoped=true"
import script from "./TransparentBox.vue?vue&type=script&lang=js"
export * from "./TransparentBox.vue?vue&type=script&lang=js"
import style0 from "./TransparentBox.vue?vue&type=style&index=0&id=41d374b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d374b8",
  null
  
)

export default component.exports